import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-messages',
  templateUrl: 'messages.html',
})
export class MessagesPage implements OnInit, OnDestroy {

  public message = null;
  interval;

  constructor(public navCtrl: NavController, public navParams: NavParams, public data: DataProvider, public http: HttpClient) {
  }

  ngOnInit() {
    this.data.loadMessageList();
    this.interval = setInterval(() => {
      this.data.loadMessageList();
    }, 10000);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  ionViewDidLoad() {
  }

  send() {
    const body = {
      token: localStorage.getItem('token'),
      module: 'messages',
      submodule: 'add',
      message: this.message
    };
    const sub = this.http.post(environment.api_url, body).subscribe(daten => {
      this.message = null;
      this.data.messages = daten['data'];
      if (this.data.messages[0] !== undefined) {
        localStorage.setItem('last_message_timestamp', this.data.messages[0].timestamp);
      }
      sub.unsubscribe();
      }, error => {
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/messages/messages.ts